export default __webpack_public_path__ + "static/media/oemLogo21.9d0ebfa3.jpg";